import type { QueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@app/constants/service';

const invalidateChatMedia = (
  chatId: string | undefined,
  queryClient: Pick<QueryClient, 'invalidateQueries'> | undefined,
) => {
  if (chatId && queryClient) {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.CHAT_MEDIA(chatId),
    });
  }
};

export default invalidateChatMedia;
